(function () {
  var META_PIXEL_ID = '3332476403579602';
  var ATTR_STORAGE_KEY = 'sabibi_attribution_v1';
  var CURRENCY = 'AED';

  // Canonical waitlist/product contract used across Meta / dataLayer / Shopify.analytics
  var WAITLIST_FORM_IDS = {
    WSYUNT: {
      source: 'join_the_waitlist_page',
      form_context: 'general_waitlist',
      content_name: 'Everyday Ease Waitlist',
      content_category: 'waitlist',
      list_name: 'Everyday Ease Waitlist'
    },
    VDAe4D: {
      source: 'product_waitlist',
      form_context: 'product_waitlist',
      product_handle: 'alaia-oversized-structured-set',
      content_name: 'Alaia Oversized Structured Set',
      content_category: 'waitlist',
      content_type: 'product',
      content_ids: ['8576174162055'],
      product_id: '8576174162055',
      value: 595,
      currency: CURRENCY
    },
    YxnW9W: {
      source: 'product_waitlist',
      form_context: 'product_waitlist',
      product_handle: 'zaytoun-relaxed-set',
      content_name: 'Zaytoun Relaxed Set',
      content_category: 'waitlist',
      content_type: 'product',
      content_ids: ['8576204112007'],
      product_id: '8576204112007',
      value: 495,
      currency: CURRENCY
    },
    WWm5wK: {
      source: 'product_waitlist',
      form_context: 'product_waitlist',
      product_handle: 'solis-2-way-cotton-shirt',
      content_name: 'Solis 2-Way Cotton Shirt',
      content_category: 'waitlist',
      content_type: 'product',
      content_ids: ['8576236912775'],
      product_id: '8576236912775',
      value: 295,
      currency: CURRENCY
    }
  };

  var PRODUCT_BY_HANDLE = {
    'alaia-oversized-structured-set': WAITLIST_FORM_IDS.VDAe4D,
    'zaytoun-relaxed-set': WAITLIST_FORM_IDS.YxnW9W,
    'solis-2-way-cotton-shirt': WAITLIST_FORM_IDS.WWm5wK
  };

  var leadDedupe = Object.create(null);
  var fbqEnsurePromise = null;
  var metaPixelInitDone = false;
  var attributionBootstrapped = false;

  function openKlaviyoForm(formId) {
    if (!formId) return false;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    return true;
  }

  function handleWaitlistClick(event) {
    var trigger = event.target.closest('[data-sabibi-waitlist-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var formId = trigger.getAttribute('data-klaviyo-form-id');
    if (!openKlaviyoForm(formId)) {
      console.warn('SABIBI waitlist form ID is missing for', trigger.getAttribute('data-product-handle'));
    }
  }

  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function readProductIdentityFromDom() {
    var el =
      document.querySelector('[data-sabibi-waitlist-trigger]') ||
      document.querySelector('product-form-component[data-product-id]') ||
      document.querySelector('[data-product-id][data-product-handle]');
    if (!el) return null;

    var priceRaw = el.getAttribute('data-product-price') || '';
    var price = parseFloat(String(priceRaw).replace(/[^0-9.]/g, ''));
    return {
      product_id: el.getAttribute('data-product-id') || '',
      product_handle: el.getAttribute('data-product-handle') || getProductHandle() || '',
      product_title: el.getAttribute('data-product-title') || el.getAttribute('data-product-name') || '',
      product_price: isNaN(price) ? null : price,
      currency: el.getAttribute('data-currency') || 'AED',
      form_id: el.getAttribute('data-form-id') || el.getAttribute('data-klaviyo-form-id') || '',
      form_context: el.getAttribute('data-form-context') || 'product_waitlist'
    };
  }

  function isWaitlistPage() {
    return /\/pages\/join-the-waitlist\/?$/.test(window.location.pathname);
  }

  function safeStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (err) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (err) {
      return false;
    }
  }

  function getCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (err) {
      return '';
    }
  }

  function readQueryParams() {
    var out = {};
    try {
      var params = new URLSearchParams(window.location.search || '');
      [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'fbclid',
        'gclid',
        'ttclid'
      ].forEach(function (key) {
        var value = params.get(key);
        if (value) out[key] = value;
      });
    } catch (err) {
      // non-blocking
    }
    return out;
  }

  function bootstrapAttribution() {
    if (attributionBootstrapped) return getAttribution();
    attributionBootstrapped = true;

    var existing = null;
    try {
      existing = JSON.parse(safeStorageGet(ATTR_STORAGE_KEY) || 'null');
    } catch (err) {
      existing = null;
    }

    var incoming = readQueryParams();
    var nowIso = new Date().toISOString();
    var firstTouch = existing && existing.first_touch ? existing.first_touch : null;
    var hasIncoming = Object.keys(incoming).length > 0;

    if (!firstTouch) {
      firstTouch = {
        captured_at: nowIso,
        landing_page: window.location.href,
        landing_path: window.location.pathname,
        referrer: document.referrer || '',
        utm_source: incoming.utm_source || '',
        utm_medium: incoming.utm_medium || '',
        utm_campaign: incoming.utm_campaign || '',
        utm_content: incoming.utm_content || '',
        utm_term: incoming.utm_term || '',
        fbclid: incoming.fbclid || '',
        gclid: incoming.gclid || '',
        ttclid: incoming.ttclid || ''
      };
    }

    var lastTouch = hasIncoming
      ? {
          captured_at: nowIso,
          page: window.location.href,
          path: window.location.pathname,
          utm_source: incoming.utm_source || '',
          utm_medium: incoming.utm_medium || '',
          utm_campaign: incoming.utm_campaign || '',
          utm_content: incoming.utm_content || '',
          utm_term: incoming.utm_term || '',
          fbclid: incoming.fbclid || '',
          gclid: incoming.gclid || '',
          ttclid: incoming.ttclid || ''
        }
      : (existing && existing.last_touch) || firstTouch;

    var attribution = {
      version: 1,
      first_touch: firstTouch,
      last_touch: lastTouch,
      updated_at: nowIso
    };

    safeStorageSet(ATTR_STORAGE_KEY, JSON.stringify(attribution));
    return attribution;
  }

  function getAttribution() {
    try {
      var parsed = JSON.parse(safeStorageGet(ATTR_STORAGE_KEY) || 'null');
      if (parsed && parsed.first_touch) return parsed;
    } catch (err) {
      // fall through
    }
    return bootstrapAttribution();
  }

  function extractFormId(detail) {
    if (!detail) return '';

    return String(
      detail.formId ||
        detail.formID ||
        detail.form_id ||
        (detail.meta && (detail.meta.formId || detail.meta.form_id || detail.meta.formID)) ||
        (detail.form && (detail.form.id || detail.form.formId || detail.form.formID)) ||
        ''
    );
  }

  function extractEmail(detail) {
    if (!detail) return '';
    var candidates = [
      detail.email,
      detail.Email,
      detail.$email,
      detail.meta && detail.meta.email,
      detail.meta && detail.meta.$email,
      detail.form && detail.form.email,
      detail.values && (detail.values.email || detail.values.$email || detail.values.Email)
    ];
    for (var i = 0; i < candidates.length; i += 1) {
      if (candidates[i] && typeof candidates[i] === 'string' && candidates[i].indexOf('@') > 0) {
        return candidates[i].trim().toLowerCase();
      }
    }
    return '';
  }

  function isKnownWaitlistForm(formId) {
    return !!formId && Object.prototype.hasOwnProperty.call(WAITLIST_FORM_IDS, formId);
  }

  function shouldTrackLead(formId) {
    if (isKnownWaitlistForm(formId)) return true;
    if (isWaitlistPage()) return true;
    if (getProductHandle() && document.querySelector('[data-sabibi-waitlist-trigger]')) return true;
    return false;
  }

  function resolveFormConfig(formId, productHandle) {
    if (formId && WAITLIST_FORM_IDS[formId]) return WAITLIST_FORM_IDS[formId];
    if (productHandle && PRODUCT_BY_HANDLE[productHandle]) return PRODUCT_BY_HANDLE[productHandle];
    if (isWaitlistPage()) return WAITLIST_FORM_IDS.WSYUNT;
    return {
      source: 'waitlist',
      form_context: productHandle ? 'product_waitlist' : 'general_waitlist',
      content_name: productHandle || 'Waitlist',
      content_category: 'waitlist'
    };
  }

  function buildLeadContract(options) {
    options = options || {};
    var domIdentity = readProductIdentityFromDom() || {};
    var formId = options.formId || domIdentity.form_id || '';
    var productHandle = options.productHandle || domIdentity.product_handle || getProductHandle();
    var config = resolveFormConfig(formId, productHandle);
    var attribution = getAttribution();
    var email = options.email || '';

    var productId = domIdentity.product_id || config.product_id || '';
    var productTitle = domIdentity.product_title || config.content_name || '';
    var productValue =
      typeof domIdentity.product_price === 'number'
        ? domIdentity.product_price
        : typeof config.value === 'number'
          ? config.value
          : undefined;
    var currency = domIdentity.currency || config.currency || CURRENCY;

    var contract = {
      event_name: 'Lead',
      event_id: options.eventId || '',
      form_id: formId || (config === WAITLIST_FORM_IDS.WSYUNT ? 'WSYUNT' : ''),
      form_context:
        config.form_context ||
        domIdentity.form_context ||
        (productHandle ? 'product_waitlist' : 'general_waitlist'),
      content_name: productTitle || config.content_name || 'Waitlist',
      content_category: config.content_category || 'waitlist',
      page_location: window.location.href,
      page_path: window.location.pathname,
      currency: currency,
      landing_page:
        (attribution && attribution.first_touch && attribution.first_touch.landing_page) ||
        window.location.href,
      referrer:
        (attribution && attribution.first_touch && attribution.first_touch.referrer) ||
        document.referrer ||
        '',
      first_visit_at:
        (attribution && attribution.first_touch && attribution.first_touch.captured_at) || ''
    };

    if (config.content_type || productId || productHandle) contract.content_type = config.content_type || 'product';
    if (productId) {
      contract.product_id = String(productId);
      contract.content_ids = [String(productId)];
    } else if (config.content_ids) {
      contract.content_ids = config.content_ids.slice();
      if (config.product_id) contract.product_id = config.product_id;
    }
    if (typeof productValue === 'number') contract.value = productValue;
    if (config.product_handle || productHandle) {
      contract.product_handle = config.product_handle || productHandle;
    }
    if (productTitle) contract.product_name = productTitle;
    if (config.list_name) contract.list_name = config.list_name;
    if (email) contract.email = email;

    if (attribution && attribution.first_touch) {
      contract.attribution = {
        first_touch: attribution.first_touch,
        last_touch: attribution.last_touch || null
      };
      contract.utm_source = (attribution.last_touch && attribution.last_touch.utm_source) || attribution.first_touch.utm_source || '';
      contract.utm_medium = (attribution.last_touch && attribution.last_touch.utm_medium) || attribution.first_touch.utm_medium || '';
      contract.utm_campaign = (attribution.last_touch && attribution.last_touch.utm_campaign) || attribution.first_touch.utm_campaign || '';
      contract.utm_content = (attribution.last_touch && attribution.last_touch.utm_content) || attribution.first_touch.utm_content || '';
      contract.utm_term = (attribution.last_touch && attribution.last_touch.utm_term) || attribution.first_touch.utm_term || '';
      contract.fbclid = (attribution.last_touch && attribution.last_touch.fbclid) || attribution.first_touch.fbclid || '';
    }

    contract.fbp = getCookie('_fbp') || '';
    contract.fbc = getCookie('_fbc') || '';

    return contract;
  }

  function toMetaCustomData(contract) {
    var data = {
      content_name: contract.content_name,
      content_category: contract.content_category,
      status: 'subscribed'
    };
    if (contract.form_id) data.form_id = contract.form_id;
    if (contract.form_context) data.form_context = contract.form_context;
    if (contract.content_type) data.content_type = contract.content_type;
    if (contract.content_ids) data.content_ids = contract.content_ids;
    if (typeof contract.value === 'number') data.value = contract.value;
    if (contract.currency) data.currency = contract.currency;
    if (contract.product_handle) data.product_handle = contract.product_handle;
    return data;
  }

  function installFbqStub() {
    if (typeof window.fbq === 'function') return;

    var n = function () {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments);
      } else {
        n.queue.push(arguments);
      }
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
  }

  function loadFbeventsScript() {
    return new Promise(function (resolve) {
      var existing = document.querySelector('script[src*="connect.facebook.net"][src*="fbevents.js"]');
      if (existing) {
        if (existing.getAttribute('data-sabibi-loaded') === 'true' || existing.dataset.sabibiLoaded === 'true') {
          resolve(true);
          return;
        }
        var settled = false;
        var done = function () {
          if (settled) return;
          settled = true;
          resolve(true);
        };
        existing.addEventListener('load', done);
        existing.addEventListener('error', done);
        setTimeout(done, 1800);
        return;
      }

      installFbqStub();

      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.setAttribute('data-sabibi-fbevents', '1');
      var settled = false;
      var done = function () {
        if (settled) return;
        settled = true;
        script.setAttribute('data-sabibi-loaded', 'true');
        resolve(true);
      };
      script.onload = done;
      script.onerror = done;
      (document.head || document.documentElement).appendChild(script);
      setTimeout(done, 2000);
    });
  }

  function initMetaPixelOnce(userData) {
    if (typeof window.fbq !== 'function') return false;

    try {
      if (userData && userData.em) {
        // Re-init with advanced matching identifiers when available.
        window.fbq('init', META_PIXEL_ID, userData);
      } else if (!metaPixelInitDone && !window.__sabibiMetaPixelInit) {
        window.fbq('init', META_PIXEL_ID);
      } else if (!metaPixelInitDone) {
        window.fbq('init', META_PIXEL_ID);
      } else {
        // Ensure this pixel remains initialized even if a stub existed earlier.
        window.fbq('init', META_PIXEL_ID);
      }
      metaPixelInitDone = true;
      window.__sabibiMetaPixelInit = true;
      return true;
    } catch (err) {
      return false;
    }
  }

  function ensureFbq() {
    if (fbqEnsurePromise) return fbqEnsurePromise;

    fbqEnsurePromise = loadFbeventsScript().then(function () {
      installFbqStub();
      initMetaPixelOnce();
      return typeof window.fbq === 'function' ? window.fbq : null;
    });

    return fbqEnsurePromise;
  }

  function fireLeadBeacon(payload, eventId) {
    try {
      var params = [
        'id=' + encodeURIComponent(META_PIXEL_ID),
        'ev=Lead',
        'noscript=1',
        'dl=' + encodeURIComponent(window.location.href),
        'rl=' + encodeURIComponent(document.referrer || ''),
        'if=false',
        'ts=' + Date.now()
      ];

      if (eventId) params.push('eid=' + encodeURIComponent(eventId));
      if (payload && payload.content_name) {
        params.push('cd[content_name]=' + encodeURIComponent(payload.content_name));
      }
      if (payload && payload.content_category) {
        params.push('cd[content_category]=' + encodeURIComponent(payload.content_category));
      }
      if (payload && payload.form_id) {
        params.push('cd[form_id]=' + encodeURIComponent(payload.form_id));
      }

      var url = 'https://www.facebook.com/tr?' + params.join('&');
      var img = new Image(1, 1);
      img.referrerPolicy = 'no-referrer-when-downgrade';
      img.src = url;
    } catch (err) {
      // non-blocking
    }
  }

  function fireMetaLead(contract) {
    var payload = toMetaCustomData(contract);
    var eventId = contract.event_id;
    var userData = {};
    if (contract.email) userData.em = contract.email;
    if (contract.fbp) userData.fbp = contract.fbp;
    if (contract.fbc) userData.fbc = contract.fbc;

    return ensureFbq()
      .then(function (fbq) {
        var jsFired = false;

        if (typeof fbq === 'function') {
          try {
            initMetaPixelOnce(Object.keys(userData).length ? userData : null);
            fbq('track', 'Lead', payload || {}, { eventID: eventId });
            jsFired = true;
          } catch (err) {
            jsFired = false;
          }
        }

        // Beacon only if JS pixel path failed — prevents double browser Lead.
        if (!jsFired) {
          fireLeadBeacon(payload, eventId);
        }

        return jsFired;
      })
      .catch(function () {
        fireLeadBeacon(payload, eventId);
        return false;
      });
  }

  function publishSharedContract(contract) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('lead', contract);
        Shopify.analytics.publish('sabibi_waitlist_lead', contract);
      }
    } catch (err) {
      // non-blocking
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'generate_lead',
        sabibi_event: 'Lead',
        event_id: contract.event_id,
        form_id: contract.form_id,
        form_context: contract.form_context,
        content_name: contract.content_name,
        content_category: contract.content_category,
        content_ids: contract.content_ids || [],
        value: contract.value,
        currency: contract.currency,
        page_location: contract.page_location,
        page_path: contract.page_path,
        utm_source: contract.utm_source,
        utm_medium: contract.utm_medium,
        utm_campaign: contract.utm_campaign,
        utm_content: contract.utm_content,
        utm_term: contract.utm_term,
        fbclid: contract.fbclid
      });
    } catch (err) {
      // non-blocking
    }

    // Optional Klaviyo identify enrichment if onsite API is present.
    try {
      if (window._learnq && typeof window._learnq.push === 'function') {
        // Pass UTM/attribution as profile properties so they persist on the Klaviyo profile,
        // not just on the event. Identify with $email first, then add properties.
        var identifyProps = { $email: contract.email };
        if (contract.utm_source) identifyProps['$utm_source'] = contract.utm_source;
        if (contract.utm_medium) identifyProps['$utm_medium'] = contract.utm_medium;
        if (contract.utm_campaign) identifyProps['$utm_campaign'] = contract.utm_campaign;
        if (contract.utm_content) identifyProps['$utm_content'] = contract.utm_content;
        if (contract.utm_term) identifyProps['$utm_term'] = contract.utm_term;
        if (contract.fbclid) identifyProps['$fbclid'] = contract.fbclid;
        if (contract.form_id) identifyProps['form_id'] = contract.form_id;
        if (contract.form_context) identifyProps['form_context'] = contract.form_context;
        if (contract.product_handle) identifyProps['product_handle'] = contract.product_handle;
        if (contract.product_id) identifyProps['product_id'] = contract.product_id;
        if (contract.first_visit_at) identifyProps['first_visit_at'] = contract.first_visit_at;
        if (contract.landing_page) identifyProps['$first_landing_page_url'] = contract.landing_page;
        if (contract.referrer) identifyProps['$referrer_url'] = contract.referrer;

        if (contract.email) {
          window._learnq.push(['identify', identifyProps]);
        }

        // Add the profile to the correct waitlist list via Klaviyo API
        // by setting $list property on identify when a known form is used.
        var listId = '';
        if (contract.form_context === 'product_waitlist' && contract.product_handle) {
          if (contract.product_handle.indexOf('alaia') >= 0) listId = 'RqCEvS';
          else if (contract.product_handle.indexOf('zaytoun') >= 0) listId = 'XQETrg';
          else if (contract.product_handle.indexOf('solis') >= 0) listId = 'Ur5D76';
        } else if (contract.form_id === 'WSYUNT' || contract.form_context === 'general_waitlist') {
          listId = 'Tc5RCQ';
        }
        if (listId) identifyProps['$list'] = listId;

        window._learnq.push([
          'track',
          'Sabibi Waitlist Lead',
          {
            form_id: contract.form_id,
            form_context: contract.form_context,
            content_name: contract.content_name,
            product_id: contract.product_id || '',
            product_handle: contract.product_handle || '',
            value: contract.value || '',
            currency: contract.currency || CURRENCY,
            event_id: contract.event_id,
            page_path: contract.page_path,
            utm_source: contract.utm_source || '',
            utm_medium: contract.utm_medium || '',
            utm_campaign: contract.utm_campaign || '',
            utm_content: contract.utm_content || '',
            utm_term: contract.utm_term || '',
            fbclid: contract.fbclid || '',
            first_landing_page:
              (contract.attribution &&
                contract.attribution.first_touch &&
                contract.attribution.first_touch.landing_page) ||
              ''
          }
        ]);
      }
    } catch (err) {
      // non-blocking
    }

    // Server-side CAPI via VPS proxy — sends hashed email to Meta for better match quality.
    if (contract.email) {
      try {
        var capiUrl = 'https://capi-sabibi.theosirislabs.com/lead';
        var capiPayload = JSON.stringify({
          email: contract.email,
          event_id: contract.event_id,
          form_id: contract.form_id,
          form_context: contract.form_context,
          content_name: contract.content_name,
          content_category: contract.content_category,
          status: 'subscribed',
          value: contract.value,
          currency: contract.currency,
          from_browser: true
        });
        // Fire and forget — no await needed, CAPI is enhancement, not critical.
        if (typeof window.fetch === 'function') {
          try {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', capiUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.timeout = 3000;
            xhr.send(capiPayload);
          } catch (xhrErr) {
            // non-blocking
          }
        }
      } catch (err) {
        // non-blocking
      }
    }
  }

  function trackWaitlistLead(options) {
    options = options || {};
    var formId = options.formId || '';
    var productHandle = options.productHandle || getProductHandle();
    var config = resolveFormConfig(formId, productHandle);
    var source = options.source || config.source || 'waitlist';

    // One Lead per form/context for this page session.
    var sessionKey = [formId || 'unknown', productHandle || '', source].join('|');
    if (leadDedupe[sessionKey]) return false;
    leadDedupe[sessionKey] = true;

    var eventId =
      'sabibi_lead_' +
      (formId || 'na') +
      '_' +
      Date.now().toString(36) +
      '_' +
      Math.random().toString(36).slice(2, 8);

    var contract = buildLeadContract({
      formId: formId,
      productHandle: productHandle,
      eventId: eventId,
      email: options.email || ''
    });

    fireMetaLead(contract);
    publishSharedContract(contract);
    return true;
  }

  function markProductJoined(productHandle) {
    if (!productHandle) return;

    var storageKey = 'sabibi_waitlist_joined_' + productHandle;
    safeStorageSet(storageKey, 'true');

    var buttons = document.querySelectorAll(
      'button[name="add"], .product-form__submit, [data-sabibi-waitlist-trigger]'
    );

    buttons.forEach(function (button) {
      if (!(button instanceof HTMLElement)) return;
      button.textContent = 'Joined Waitlist';
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.style.opacity = '0.6';
      button.style.cursor = 'default';
    });
  }

  function restoreProductJoinedState() {
    var productHandle = getProductHandle();
    if (!productHandle) return;
    if (safeStorageGet('sabibi_waitlist_joined_' + productHandle) === 'true') {
      markProductJoined(productHandle);
    }
  }

  function handleKlaviyoFormEvent(event) {
    var detail = (event && event.detail) || {};
    var type = detail.type || '';

    // Final submit only — prevents submit+completed double Lead.
    if (type !== 'submit') return;

    var formId = extractFormId(detail);
    if (!shouldTrackLead(formId)) return;

    var productHandle = getProductHandle();
    var meta = formId && WAITLIST_FORM_IDS[formId];
    var email = extractEmail(detail);

    if (productHandle && document.querySelector('[data-sabibi-waitlist-trigger]')) {
      var isPageOnlyForm = meta && meta.form_context === 'general_waitlist';
      if (!isPageOnlyForm) {
        markProductJoined(productHandle);
      }
    }

    trackWaitlistLead({
      formId: formId,
      productHandle: productHandle,
      email: email,
      source: meta && meta.source ? meta.source : productHandle ? 'product_waitlist' : 'waitlist'
    });
  }

  function prepareProductVideo(video) {
    if (!video || video.dataset.sabibiLaunchPrepared === 'true') return;

    video.dataset.sabibiLaunchPrepared = 'true';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'metadata');

    video.addEventListener('ended', function () {
      video.currentTime = 0;
      video.play().catch(function () {});
    });

    video.addEventListener('timeupdate', function () {
      if (video.duration && video.currentTime > video.duration - 0.15) {
        video.currentTime = 0;
        video.play().catch(function () {});
      }
    });
  }

  function restartFinishedVideos(root) {
    root = root || document;
    root.querySelectorAll('.product-media video').forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      prepareProductVideo(video);
    });
  }

  function watchProductVideos() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches('.product-media video')) {
            prepareProductVideo(node);
          }
          restartFinishedVideos(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function getWishlistCountText(root) {
    if (!root) return '';

    var countSelectors = [
      '[class*="count"]',
      '[class*="Count"]',
      '[class*="badge"]',
      '[class*="Badge"]',
      '[data-wishlist-count]',
      '[data-wlh-count]'
    ];

    var countNode = countSelectors
      .map(function (selector) {
        return root.querySelector(selector);
      })
      .find(function (node) {
        return (
          node &&
          /\d+/.test(
            node.textContent ||
              node.getAttribute('data-wishlist-count') ||
              node.getAttribute('data-wlh-count') ||
              ''
          )
        );
      });

    return countNode
      ? countNode.textContent ||
          countNode.getAttribute('data-wishlist-count') ||
          countNode.getAttribute('data-wlh-count') ||
          ''
      : '';
  }

  function syncHeaderWishlistState() {
    document.querySelectorAll('.sabibi-header-wishlist').forEach(function (wrapper) {
      var countText = getWishlistCountText(wrapper);
      var count = Number((countText.match(/\d+/) || ['0'])[0]);
      wrapper.classList.toggle('sabibi-wishlist-has-items', count > 0);
    });
  }

  function watchHeaderWishlist() {
    syncHeaderWishlistState();

    var observer = new MutationObserver(syncHeaderWishlistState);
    observer.observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('click', function () {
      window.setTimeout(syncHeaderWishlistState, 250);
    });
  }

  window.SabibiLaunch = window.SabibiLaunch || {};
  window.SabibiLaunch.trackWaitlistLead = trackWaitlistLead;
  window.SabibiLaunch.metaPixelId = META_PIXEL_ID;
  window.SabibiLaunch.ensureFbq = ensureFbq;
  window.SabibiLaunch.getAttribution = getAttribution;
  window.SabibiLaunch.buildLeadContract = buildLeadContract;
  window.SabibiLaunch.formMap = WAITLIST_FORM_IDS;

  document.addEventListener('click', handleWaitlistClick);
  // Single listener only — document+window both would double on bubbling events.
  document.addEventListener('klaviyoForms', handleKlaviyoFormEvent);

  document.addEventListener('DOMContentLoaded', function () {
    bootstrapAttribution();
    restoreProductJoinedState();
    restartFinishedVideos();
    watchProductVideos();
    watchHeaderWishlist();
  });

  // Bootstrap attribution immediately for late-loaded deferred script cases.
  bootstrapAttribution();

  document.addEventListener('shopify:section:load', restartFinishedVideos);
  document.addEventListener('shopify:section:load', syncHeaderWishlistState);
  document.addEventListener('shopify:section:load', restoreProductJoinedState);
})();
